var _defs, _use, _use2, _use3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeasedwaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0.0 0.0 56.0 56.0",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s-Path_1-d1224",
    d: "M0.0 0.0 L56.0 0.0 L56.0 56.0 L0.0 56.0 Z "
  }), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    id: "s-Path_1-d1224_effects"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "saturate",
    values: 2,
    result: "SATURATE_0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "s-Path_2-d1224",
    d: "M0.0 0.0 L56.0 0.0 L56.0 56.0 L0.0 56.0 Z "
  }), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    id: "s-Path_2-d1224_effects"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "BLUR_0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "s-Path_3-d1224",
    d: "M28.0 12.0 L44.0 28.0 L28.0 44.0 L12.0 28.0 L28.0 12.0 Z "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    },
    filter: "url(#s-Path_1-d1224_effects)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#s-Path_1-d1224",
    fill: "#000000",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    },
    filter: "url(#s-Path_2-d1224_effects)"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#s-Path_2-d1224",
    fill: "#0055FF",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#s-Path_3-d1224",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeasedwaves);
export default __webpack_public_path__ + "static/media/LEASEDWAVES.bf221ddb9d169f5640827f7388ae6fd3.svg";
export { ForwardRef as ReactComponent };